var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "report-item" }, [
    _c("div", { staticClass: "report-item__data" }, [
      _c(
        "div",
        { staticClass: "report-item__name" },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "olap-report",
                  params: { id: _vm.report.id },
                  query: { code: _vm.code },
                },
              },
            },
            [_vm._v(_vm._s(_vm.report.name))]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "report-item__meta" }, [
        _vm.report.responsible
          ? _c(
              "div",
              { staticClass: "report-item__responsible" },
              [
                _c("svg-icon", {
                  staticClass: "icon",
                  attrs: { size: 16, name: "user" },
                }),
                _vm._v(" " + _vm._s(_vm.report.responsible.name) + " "),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "report-item__actions" },
      [
        _c("c-button", {
          staticClass: "report-item__menu",
          attrs: {
            id: `report-actions-${_vm.report.id}`,
            tabindex: "-1",
            size: "iconic",
            icon: "menu",
          },
        }),
        _c("c-button", {
          directives: [
            {
              name: "b-popover",
              rawName: "v-b-popover.html",
              value: {
                container: "#app",
                trigger: "hover blur",
                boundary: "window",
                content: "Переместить",
                placement: "top",
              },
              expression:
                "{\n        container: '#app',\n        trigger: 'hover blur',\n        boundary: 'window',\n        content: 'Переместить',\n        placement: 'top',\n      }",
              modifiers: { html: true },
            },
          ],
          staticClass: "report-item__move",
          attrs: { size: "iconic", icon: "arrows-constructor" },
        }),
        _c("dropdown-menu", {
          attrs: {
            target: `report-actions-${_vm.report.id}`,
            list: _vm.actions,
            "custom-class": "report-menu",
          },
          on: { click: _vm.onClick },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }